<script setup>
import { reactive } from 'vue'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'

const state = reactive({
    options: {
        arrows: false
    }
})
</script>

<template>
    <section class="c-testimonials">
        <div class="container">
            <div class="c-testimonials__carousel">
                <Splide :options="state.options" :has-track="false">
                    <div class="c-testimonials__carousel-inner">
                        <SplideTrack>
                            <SplideSlide>
                                <div class="row">
                                    <div class="col-lg-11 offset-lg-1">
                                        <div class="carousel-item">
                                            <div class="left">
                                                <p>
                                                    Čo sa mi na TRANSFER-i páči? Človek sa tu sústavne ďalej v
                                                    zdeláva!Nie je to prínosné len pre mňa,ale aj pre spoločnosť,
                                                    v ktorej pracujem.
                                                </p>
                                                <span class="name">
                                                    NINA NOWOTNY
                                                </span>
                                                <span class="role">
                                                    Mzdová účtovníčka
                                                </span>
                                            </div>
                                            <div class="right">
                                                <figure>
                                                    <picture>
                                                        <img src="/img/person.png" alt="">
                                                    </picture>
                                                </figure>
                                                <div class="quote hidden-md-up">
                                                    <img src="/img/quote.svg" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div class="row">
                                    <div class="col-lg-11 offset-lg-1">
                                        <div class="carousel-item">
                                            <div class="left">
                                                <p>
                                                    Čo sa mi na TRANSFER-i páči? Človek sa tu sústavne ďalej v
                                                    zdeláva!Nie je to prínosné len pre mňa,ale aj pre spoločnosť,
                                                    v ktorej pracujem.
                                                </p>
                                                <span class="name">
                                                    NINA NOWOTNY
                                                </span>
                                                <span class="role">
                                                    Mzdová účtovníčka
                                                </span>
                                            </div>
                                            <div class="right">
                                                <figure>
                                                    <picture>
                                                        <img src="/img/person.png" alt="">
                                                    </picture>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div class="row">
                                    <div class="col-lg-11 offset-lg-1">
                                        <div class="carousel-item">
                                            <div class="left">
                                                <p>
                                                    Čo sa mi na TRANSFER-i páči? Človek sa tu sústavne ďalej v
                                                    zdeláva!Nie je to prínosné len pre mňa,ale aj pre spoločnosť,
                                                    v ktorej pracujem.
                                                </p>
                                                <span class="name">
                                                    NINA NOWOTNY
                                                </span>
                                                <span class="role">
                                                    Mzdová účtovníčka
                                                </span>
                                            </div>
                                            <div class="right">
                                                <figure>
                                                    <picture>
                                                        <img src="/img/person.png" alt="">
                                                    </picture>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div class="row">
                                    <div class="col-lg-11 offset-lg-1">
                                        <div class="carousel-item">
                                            <div class="left">
                                                <p>
                                                    Čo sa mi na TRANSFER-i páči? Človek sa tu sústavne ďalej v
                                                    zdeláva!Nie je to prínosné len pre mňa,ale aj pre spoločnosť,
                                                    v ktorej pracujem.
                                                </p>
                                                <span class="name">
                                                    NINA NOWOTNY
                                                </span>
                                                <span class="role">
                                                    Mzdová účtovníčka
                                                </span>
                                            </div>
                                            <div class="right">
                                                <figure>
                                                    <picture>
                                                        <img src="/img/person.png" alt="">
                                                    </picture>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                        </SplideTrack>
                    </div>
        
                </Splide>
            </div>
        </div>
    </section>
</template>